import { useContext } from 'react';
import { useMutation } from 'react-apollo';
import { login } from '@jetshop/core/data/mutations/accountMutations.gql';
import AuthContext from '../components/AuthContext/AuthContext';
const useLoginMutation = () => {
    const { updateLoggedIn } = useContext(AuthContext);
    const [loginMutation] = useMutation(login, {
        onCompleted: data => {
            updateLoggedIn(!!data.login.token, data.login.token.value);
        }
    });
    return { loginMutation };
};
export { useLoginMutation };
//# sourceMappingURL=useLoginMutation.js.map